import React, { FC, useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import styled from '@emotion/styled';

interface CardImageItemProps {
  src: string | null | undefined;
  alt?: string;
  className?: string;
  fallbackSrc?: string;
}

const StyledImageContainer = styled(Grid)`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
`;

const DEFAULT_FALLBACK = '/app-images/not-found-image/place_holder_image.png';

const CardImageItem: FC<CardImageItemProps> = ({
  src,
  alt = '',
  className,
  fallbackSrc = DEFAULT_FALLBACK
}) => {
  const [imgSrc, setImgSrc] = useState(src || fallbackSrc);

  useEffect(() => {
    setImgSrc(src || fallbackSrc);
  }, [src, fallbackSrc]);

  const handleError = () => {
    if (imgSrc !== fallbackSrc) {
      setImgSrc(fallbackSrc);
    }
  };

  return (
    <StyledImageContainer className={className}>
      <StyledImage
        src={imgSrc}
        alt={alt}
        onError={handleError}
      />
    </StyledImageContainer>
  );
};

export { CardImageItem };